import React from 'react';
import { BarChartIcon, LineChartIcon, PieChartIcon } from 'lucide-react';
export const ServicesSection = () => {
  return <section id="services" className="py-16 bg-slate-50" data-id="element-184" data-mp="2u8tdoufp3635">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185" data-mp="2galjgua1mivo">
        <div className="lg:text-center" data-id="element-186" data-mp="2ga3cb2luek8z">
          <h2 className="text-base text-[#D4AF37] font-semibold tracking-wide uppercase" data-id="element-187" data-mp="2l8wu3785wxey">
            Our Services
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-800 sm:text-4xl" data-id="element-188" data-mp="26jqlwtrcjwux">
            Investment Strategies
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-600 lg:mx-auto" data-id="element-189" data-mp="1xjtzyzwcdc3k">
            We offer a range of carefully crafted investment approaches tailored
            to different financial goals and risk profiles, with a focus on the
            Indian market.
          </p>
        </div>
        <div className="mt-16" data-id="element-190" data-mp="1no0kb7nbt2hk">
          <div className="space-y-12 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-8" data-id="element-191" data-mp="1sl0nnassjr4z">
            <div className="relative p-8 bg-white rounded-lg shadow-sm" data-id="element-192" data-mp="2pn1bnrcrgsk1">
              <div className="flex items-center justify-center h-16 w-16 rounded-md bg-[#D4AF37] text-white mx-auto" data-id="element-193" data-mp="2pp49uyo2hrzu">
                <LineChartIcon size={32} data-id="element-194" data-mp="2ynple9v4g6r4" />
              </div>
              <h3 className="mt-6 text-xl font-bold text-slate-800 text-center" data-id="element-195" data-mp="2yn6edo70f2rv">
                Long-term Growth
              </h3>
              <p className="mt-4 text-base text-slate-600 text-center" data-id="element-196" data-mp="26wjv0l57dnf1">
                Strategic investments in high-quality Indian assets with strong
                growth potential over extended time horizons.
              </p>
              <ul className="mt-6 space-y-2" data-id="element-197" data-mp="2fq57tyxt4ult">
                <li className="flex items-start" data-id="element-198" data-mp="2fqy8ci66anvi">
                  <div className="flex-shrink-0" data-id="element-199" data-mp="2axc33b2c9m9q">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-200" data-mp="2awk73z4txmix">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-201" data-mp="1j77cuvrwe50l"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-202" data-mp="3iciksob6yaav">
                    Equity-focused portfolios
                  </p>
                </li>
                <li className="flex items-start" data-id="element-203" data-mp="3n98vew488dow">
                  <div className="flex-shrink-0" data-id="element-204" data-mp="3s1ik68tlv7pl">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-205" data-mp="3s3vb3bhccses">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-206" data-mp="xk7p8ouzfka"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-207" data-mp="34bxznlht02e7">
                    Dividend growth strategies
                  </p>
                </li>
                <li className="flex items-start" data-id="element-208" data-mp="399psqiu6pujz">
                  <div className="flex-shrink-0" data-id="element-209" data-mp="3ea43i8n67ilp">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-210" data-mp="3ebyjr9nhymjg">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-211" data-mp="oksc7oegqkl9"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-212" data-mp="2e27cqux1deod">
                    Technology and innovation focus
                  </p>
                </li>
              </ul>
            </div>
            <div className="relative p-8 bg-white rounded-lg shadow-sm" data-id="element-213" data-mp="295gm5dnlv0op">
              <div className="flex items-center justify-center h-16 w-16 rounded-md bg-[#D4AF37] text-white mx-auto" data-id="element-214" data-mp="24at705ehrims">
                <BarChartIcon size={32} data-id="element-215" data-mp="1zb6sztqu9ycx" />
              </div>
              <h3 className="mt-6 text-xl font-bold text-slate-800 text-center" data-id="element-216" data-mp="1uf9fdv6yn63u">
                Balanced Portfolios
              </h3>
              <p className="mt-4 text-base text-slate-600 text-center" data-id="element-217" data-mp="1qeph2oanhwg4">
                Diversified investment mix designed to balance growth with
                income and capital preservation across Indian markets.
              </p>
              <ul className="mt-6 space-y-2" data-id="element-218" data-mp="3fs2paolvw4mi">
                <li className="flex items-start" data-id="element-219" data-mp="3fqrlwpwcoyvx">
                  <div className="flex-shrink-0" data-id="element-220" data-mp="3ary7mv98p3up">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-221" data-mp="3at97wl3h7th2">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-222" data-mp="28cxk8dur9wlo"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-223" data-mp="1ygujncfjy60u">
                    Multi-asset allocation
                  </p>
                </li>
                <li className="flex items-start" data-id="element-224" data-mp="23ennhytdunxy">
                  <div className="flex-shrink-0" data-id="element-225" data-mp="1or2nwevpv6us">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-226" data-mp="1oq9fl9h409aj">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-227" data-mp="1tjc6tayez6nk"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-228" data-mp="1fo9xsey9t16j">
                    Income-generating securities
                  </p>
                </li>
                <li className="flex items-start" data-id="element-229" data-mp="15t85594sdgz7">
                  <div className="flex-shrink-0" data-id="element-230" data-mp="15uja3c9ywurw">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-231" data-mp="1aq8cdnddgprw">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-232" data-mp="r69hzqcyp8qa"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-233" data-mp="n5pn6tfv2h7b">
                    Risk-adjusted returns
                  </p>
                </li>
              </ul>
            </div>
            <div className="relative p-8 bg-white rounded-lg shadow-sm" data-id="element-234" data-mp="w2zvc5xdtq80">
              <div className="flex items-center justify-center h-16 w-16 rounded-md bg-[#D4AF37] text-white mx-auto" data-id="element-235" data-mp="1a3kdr0zdxk0z">
                <PieChartIcon size={32} data-id="element-236" data-mp="161z7vzl9q60a" />
              </div>
              <h3 className="mt-6 text-xl font-bold text-slate-800 text-center" data-id="element-237" data-mp="1jtvuxp82xppt">
                Alternative Investments
              </h3>
              <p className="mt-4 text-base text-slate-600 text-center" data-id="element-238" data-mp="1ewdms11vzeiv">
                Specialized opportunities in the Indian market to enhance
                returns and diversification.
              </p>
              <ul className="mt-6 space-y-2" data-id="element-239" data-mp="1out8tpm23xli">
                <li className="flex items-start" data-id="element-240" data-mp="1vwq60prgp04n">
                  <div className="flex-shrink-0" data-id="element-241" data-mp="1vy15iddvjlpy">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-242" data-mp="20v0170d6s0q9">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-243" data-mp="25u48tmkgpqeh"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-244" data-mp="2am4g602v3ll3">
                    Private equity opportunities
                  </p>
                </li>
                <li className="flex items-start" data-id="element-245" data-mp="2jm0vvc79xa40">
                  <div className="flex-shrink-0" data-id="element-246" data-mp="2jkpshdhqq4df">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-247" data-mp="2ol41oyv2vkd1">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-248" data-mp="2tjyk3zp4v6wm"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-249" data-mp="u84ikvrho810">
                    Real estate investments
                  </p>
                </li>
                <li className="flex items-start" data-id="element-250" data-mp="z8a55xiwj4c8">
                  <div className="flex-shrink-0" data-id="element-251" data-mp="rnq1cv2uba8q">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-252" data-mp="rohn7e6mxtlt">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-253" data-mp="hwv28q4hwg5v"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-254" data-mp="cyabrif1paum">
                    Infrastructure projects
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
};